import {fromJS} from 'immutable';
import moment from 'moment';

import ParticipationAction from '../actions/ParticipationActions';
import {getError} from '../utils/Utils';

export const DEFAULT_STATE = fromJS({
    eventInfo: {
        eventName: '',
        eventOrganizer: '',
        eventStartDate: ''
    },
    playerInfo: {
        firstName: '',
        lastName: '',
        guardianFirstName: '',
        guardianLastName: '',
        guardianSignature: '',
        signatureDate: '',
        relationship: 'Parent',
        isMinor: false,
        dateOfBirth: '',
        email: '',
        elapsedYears: 0,
        signature: ''
    },
    loading: true,
    error: null,
    invalid: null,
    mismatch: false,
    agreed: true
});

const {
    GET_PARTICIPATION_FORM,
    GET_PARTICIPATION_FORM_SUCCESS,
    GET_PARTICIPATION_FORM_FAILED,
    SET_PLAYER_FORM,
    SAVE_PARTICIPATION_FORM,
    SAVE_PARTICIPATION_FORM_SUCCESS,
    SAVE_PARTICIPATION_FORM_FAILED,
    HIDE_ERROR_MODAL,
    SHOW_MISMATCH_MODAL
} = ParticipationAction.TYPES;

export default function(state = DEFAULT_STATE, action) {
    let newState = state;
    switch (action.type) {
        case SHOW_MISMATCH_MODAL: {
            newState = newState.updateIn(['mismatch'], () => true);
            return newState;
        }

        case GET_PARTICIPATION_FORM: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }

        case GET_PARTICIPATION_FORM_SUCCESS: {
            const { payload } = action;
            const { eventInfo, playerInfo } = payload;
            const currentStatePlayer = newState.toJS().playerInfo;
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['eventInfo'], () => eventInfo);
            let elapsedYears = 0;
            let isMinor = false;
            if (playerInfo.details) {
                elapsedYears = moment().diff(playerInfo.details.dateOfBirth, 'years');
                // to cover the old player data in participation
                if (playerInfo.details.isMinor === undefined) {
                    if (elapsedYears < 18) {
                        isMinor = true;
                    }
                } else {
                    isMinor = playerInfo.details.isMinor;
                }
            }
            newState = newState.updateIn(['agreed'], () => playerInfo && !!playerInfo.agreed);
            newState = newState.updateIn(['playerInfo'], () => ({...currentStatePlayer, ...playerInfo.details, elapsedYears, isMinor, email: playerInfo.email}));
            return newState;
        }

        case GET_PARTICIPATION_FORM_FAILED: {
            const error = getError({error: action.payload});
            if (error.status === 'Error' && (error.errorCode === 'error.common.unauthorize' ||
                    error.errorCode === 'errors.com.epicgames.ecommerce.payout.field.value.is_invalid' ||
                    error.errorCode === 'errors.com.epicgames.ecommerce.payout.recordcount.mismatch')) {
                newState = newState.updateIn(['invalid'], () => error);
            }
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['mismatch'], () => true);
            return newState;
        }

        case SET_PLAYER_FORM: {
            const currentState = newState.toJS().playerInfo;
            const { payload } = action;
            let elapsedYears = 0;
            if (payload.dateOfBirth) {
                elapsedYears = moment().diff(payload.dateOfBirth, 'years');
            }
            const playerInfo = {...currentState, ...payload, elapsedYears};
            newState = newState.updateIn(['playerInfo'], () => fromJS({...playerInfo}));
            return newState;
        }


        case SAVE_PARTICIPATION_FORM: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }

        case SAVE_PARTICIPATION_FORM_SUCCESS: {
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['agreed'], () => true);
            return newState;
        }

        case SAVE_PARTICIPATION_FORM_FAILED: {
            const error = getError({error: action.payload});
            if (error.status === 'Error') {
                newState = newState.updateIn(['error'], () => error);
            }
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case HIDE_ERROR_MODAL: {
            newState = newState.updateIn(['error'], () => '');
            newState = newState.updateIn(['mismatch'], () => false);
            return newState;
        }

        default:
            return newState;
    }
}

